import cx from 'classnames';
import React from 'react';

import { prepareInstruction } from '../__code-container/utils';
import RobotHelp from '../__help/robot__help';
import { MarkdownExtXContent } from '../../markdown/markdown';
import { useRobotSelector } from '../context';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot__info.module.scss';

const RobotInfo = (props: { showHelp?: boolean; showTitle?: boolean; mix?: string }) => {
    const options = useRobotSelector((s) => s.problem.markup.options);
    const { showHelp = true, showTitle = true, mix } = props;

    return (
        <div className={cx(mix, styles.info)}>
            {showTitle && (
                <h3 className={cx(styles.instruction, 'qa_robot-info-title')}>
                    {prepareInstruction(options.instruction)}
                </h3>
            )}
            <MarkdownExtXContent mix={'qa_robot-info-content'}>{options.description}</MarkdownExtXContent>
            {showHelp && <RobotHelp />}
        </div>
    );
};

export default RobotInfo;
